import stateManager from './StateManager'
import animate from './modules/animations'
import menu from './modules/Menu'
import cookieConsent from './components/CookieConsent.js'
import countdown from './components/Countdown.js'
import menuItem from './components/MenuItem'
// import { cursor } from './components/cursor';
import { hero } from './modules/hero'
import { campInfo } from './modules/camp-info'
import header from './modules/header'
import modal from './modules/modal'
import cta from './blocks/cta'
import stacked from './blocks/stacked'
import testimonials from './blocks/testimonials'
import skewed from './blocks/skewed'
import modalSimple from './modules/modal-simple'
import lightboxForm from './modules/lightbox-form'
import faq from './blocks/faq'
import newsletter from './blocks/newsletter'
import blog from '@templates/blog'

export default {
    init() {
        stateManager()
        Alpine.data('menu', menu)
        Alpine.data('menuItem', menuItem)
        Alpine.data('cookieConsent', cookieConsent)
        Alpine.data('countdown', countdown)
        Alpine.data('blog', blog)
        Alpine.start()
        animate.init()
        // cursor();
        hero()
        campInfo()
    },

    finalize() {
        header.init()
        modal.init()
        modalSimple.init()
        lightboxForm.init()
        cta.init()
        stacked.init()
        testimonials.init()
        skewed.init()
        faq.init()
        newsletter.init()
    },
}
